module.exports = __webpack_public_path__ + "static/media/wash-your-hands.a0bc6639.svg";